import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import { bucket_url } from '../../constants/const'
import Loading from '../../components/layouts/Loading'
import Error404 from '../../components/Error/Error404'
import { useParams } from 'react-router-dom'
import { Button, Col, Container, Nav, Row } from 'react-bootstrap';
// import { SiFacebook, SiTwitter } from 'react-icons/si'
import { BsFacebook, BsLinkedin, BsTwitter } from 'react-icons/bs'
import { IoLogoWhatsapp } from 'react-icons/io'
import { FaShareSquare } from 'react-icons/fa'
import { LinkContainer } from 'react-router-bootstrap';

import './blogDetails.css';
import moment from 'moment';
import BlogCard from '../../components/blogCard/blogCard.component';
import PageTitle from '../../components/pageTitle/pageTitle.component';

const BlogDetails = pros => {

    const { blogId } = useParams()

    const [selectedBlog, setSelectedBlog] = useState()
    const [relatedBlog, setRelatedBlog] = useState([])

    const { loading, blog } = useSelector(state => state.all)

    useEffect(() => {
        // let singleBlog = blog.find(item => item._id === blogId)
        // if (singleBlog) {
        setSelectedBlog(blog && blog.find(item => item._id === blogId))
        // setRelatedBlog(blog.filter(item => item.tags.includes(i))
        // }
    }, [blogId, blog])

    useEffect(() => {
        // console.log('rel selectedBlog blog', selectedBlog);
        if(selectedBlog !== undefined) {
            // console.log('in error sec', selectedBlog);
            setRelatedBlog(blog.filter(item => ('category' in item) && !!selectedBlog?.category && item.category === selectedBlog?.category && item._id !== selectedBlog?._id))
        }

    }, [blogId, blog, selectedBlog])

    useEffect(() => {
        if (selectedBlog && selectedBlog.body) {
            document.getElementById('blog-body').innerHTML = selectedBlog.body
        }
    }, [selectedBlog, blog])

    const currentUrl = encodeURI(window.location.href);

    const fallbackCopyTextToClipboard = (text) => {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          var successful = document.execCommand("copy");
          var msg = successful ? "successful" : "unsuccessful";
          console.log("Fallback: Copying text command was " + msg);
        } catch (err) {
          console.error("Fallback: Oops, unable to copy", err);
        }

        document.body.removeChild(textArea);
    }

    const copyTextToClipboard = (text) => {
        if (!navigator.clipboard) {
          fallbackCopyTextToClipboard(text);
          return;
        }
        navigator.clipboard.writeText(text).then(
          function() {
            console.log("Async: Copying to clipboard was successful!");
          },
          function(err) {
            console.error("Async: Could not copy text: ", err);
          }
        );
    }

    const shareCustom = (text, e) => {
        e.preventDefault();
        if (navigator.share) {
            navigator.share({
              title: 'Share Article',
              url: text
            }).then(() => {
              console.log('Thanks for sharing!');
            })
            .catch(console.error);
        } else {
            copyTextToClipboard(text);
            alert('Link copied to clipboard!');
        }
    }

    const loadFbApi = () => {

        window.fbAsyncInit = function() {
            window.FB.init({
                appId: '420319592989109',
                xfbml: true,
                version: 'v12.0'
            });
            window.FB.AppEvents.logPageView();
        };


        // Load the SDK asynchronously
        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }

    useEffect(() => {
        loadFbApi();
    });

    return (
        loading ? <Loading /> : selectedBlog ? <>
            <Container fluid>
                <Row>
                    <Col xs={12} className="px-0">
                        {/* {selectedBlog && <img className="blog-details-cover img-fluid" src={`${bucket_url}${selectedBlog.coverPhoto}`} alt="Cover" />} */}
                        {selectedBlog && selectedBlog.heroCover && <img className="blog-details-cover img-fluid" src={`${bucket_url}${selectedBlog.heroCover}`} alt="Cover" />}
                    </Col>
                </Row>

                <section className="article-section pt-4 pb-5">
                    <Container>
                        <Row>
                            <Col xs={12} md={{ span: 10, offset: 2 }} lg={{ span: 11, offset: 1 }}>
                                <div className="article-header w-100 py-4">
                                    <h1 className="article-title mb-4">{selectedBlog && selectedBlog.title}</h1>
                                    <div className="article-meta mb-4">
                                        <span className="text-secondary mr-1">Published at: <span>{moment(Date.parse(selectedBlog.createdAt)).format('DD MMM YYYY')}</span></span>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} md={12}>
                                <Row>
                                    <Col xs={12} md={{ span: 10, order: 1 }} lg={{ span: 11, order: 1 }}>
                                        <div id='blog-body' className="article-body pt-2 w-100 text-secondary">

                                        </div>
                                    </Col>
                                    <Col xs={12} md={{ span: 2, order: 0 }} lg={{ span: 1, order: 0 }}>
                                        <Nav className="social-icons justify-content-center align-items-center text-center">
                                            <Nav.Link target={'_blank'} href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}><BsFacebook /></Nav.Link>
                                            <Nav.Link target={'_blank'} href={`https://www.linkedin.com/cws/share?url=${currentUrl}`}><BsLinkedin /></Nav.Link>
                                            <Nav.Link target={'_blank'} href={`http://twitter.com/share?text=${selectedBlog && selectedBlog.title}&url=${currentUrl}`}><BsTwitter /></Nav.Link>
                                            <Nav.Link target={'_blank'} href={`https://wa.me/?text=${currentUrl}`} data-action="share/whatsapp/share"><IoLogoWhatsapp /></Nav.Link>
                                            <Nav.Link onClick={(e) => shareCustom(currentUrl, e)} href="#"><FaShareSquare /></Nav.Link>
                                        </Nav>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} md={12} className="mt-3">
                                <Row>
                                    <Col xs={12} md={{ span: 10, offset: 2, order: 1 }} lg={{ span: 11, offset: 1, order: 1 }} className="mt-3">
                                        <div class="fb-like" data-href={currentUrl} data-width="" data-layout="standard" data-action="like" data-size="small" data-share="true"></div>
                                    </Col>
                                    <Col xs={12} md={{ span: 10, offset: 2, order: 1 }} lg={{ span: 11, offset: 1, order: 1 }} className="mt-3">
                                        <div className="fb-comments" data-href={currentUrl} data-width="" data-numposts="5"></div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                    </Container>
                </section>

            </Container>
            {
                relatedBlog.length > 0 &&
                <section className="related-articles-section pt-4 pb-5">
                    <PageTitle
                        title="Related"
                    />
                    <Container>
                        <Row className='justify-content-center'>
                            {
                                relatedBlog.map((item, index) => {
                                    if (index < 3) {
                                        return (
                                            <Col xs={12} md={4} className="mb-5">
                                                <BlogCard
                                                    url={`/blog/${item.title.replace(/ /g, "-")}/${item._id}`}
                                                    banner={`${bucket_url}${item.coverPhoto}`}
                                                    title={item.title}
                                                    subTitle={item.excerpt}
                                                    createdAt={item.createdAt}
                                                />
                                            </Col>
                                        )
                                    }

                                    return null
                                })
                            }
                        </Row>
                    </Container>
                </section>
            }
        </> : <Error404 />
    )
}

export default BlogDetails;